/* eslint-disable no-unused-expressions */

import { createGlobalStyle } from 'styled-components';
import {
  screenMdMin,
  screenSmMax,
  black,
  gray90,
} from '@spotify-internal/encore-foundation';
import { btnLg } from './mixins';
import { navbarHeight, navbarXsHeight } from './variables';

import './spBootstrapExtended';

export const SiteGlobalStyles = createGlobalStyle`
  /* Global styles */

  body {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }

  .main {
    display: flex;
    flex-direction: column;
    flex: 1;

    &::before {
      background: linear-gradient(${black}, transparent);
      opacity: 0.2;
      height: 175px;
      content: '';
      display: block;
      width: 100%;
      position: absolute;
      margin-top: -${navbarXsHeight};
      z-index: 1;

      @media (min-width: ${screenMdMin}) {
        margin-top: -${navbarHeight};
      }
    }
  }

  .contact-us-banner {
    background: ${gray90};

    .container-contact-us {
      @media (max-width: ${screenSmMax}) {
        text-align: center;
        padding: 30px 0;
      }

      @media (min-width: ${screenMdMin}) {
        padding: 50px 0;
      }

      h3, a {
        margin: 10px 0;
      }

      @media (min-width: ${screenMdMin}) {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .btn {
          flex-shrink: 0;
          ${btnLg};
        }
      }
    }
  }
`;
